document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[href*="#opencookiebot"]').forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();

            Cookiebot.renew();
        });
    });
})
